<script>
  import CryIcon from "./icons/CryIcon.svelte"
  import { capitalize, pluralTitle } from "./helpers.js";
  import { ALL } from "./constants.js";
  export let type;
  let title = type === ALL ? "Subjects" : pluralTitle(capitalize(type));
</script>

<style>
  .empty {
    font-family: "Gayathri", sans-serif;
    display: flex;
    flex-direction: column;
    font-family: var(--font-family-heading);
    justify-content: center;
    height: calc(50vh);
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    align-items: center;
  }

  h2 {
    font-size: 2rem;
  }

  i {
    font-size: 5.5rem;
    font-style: normal;
  }
</style>

<section class="empty">
  <CryIcon className="empty-sad" />
  <h2>No {title} Found</h2>
  <p>
    You need to have started {pluralTitle(type)} for this level group before
    anything will show up here. Come back later!
  </p>
</section>
